// used only in local build
export const KRPANO_XML = '/krpano/krpano.xml';

export const KRPANO_FOV_MIN = 18;
export const KRPANO_FOV_MAX = 97;

export const KRPANO_ZOOM_STEPS = [KRPANO_FOV_MIN, 25, 38, 52.5, 70, 84.5, KRPANO_FOV_MAX];
export const KRPANO_FOV_INIT = 70;

export const krpanoInternalEvents = {
    SCENE_CHANGE: 'krpano::sceneChange',
};

export const krpanoEmittedEvents = {
    TOGGLE_GO_BACK: 'krpano::goBackToggleEvent',
    TOGGLE_ZOOM_IN: 'krpano::zoomInToggleEvent',
    TOGGLE_ZOOM_OUT: 'krpano::zoomOutToggleEvent',
};
